import { render, staticRenderFns } from "./CostItemSingleSpecialty.vue?vue&type=template&id=15be9770&scoped=true&"
import script from "./CostItemSingleSpecialty.vue?vue&type=script&lang=js&"
export * from "./CostItemSingleSpecialty.vue?vue&type=script&lang=js&"
import style0 from "./CostItemSingleSpecialty.vue?vue&type=style&index=0&id=15be9770&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be9770",
  null
  
)

export default component.exports